// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".myBox[data-v-88dc90f4] {\n  text-align: left;\n  border: 3px solid #ed6c84;\n  padding: 2.5vw;\n  margin: 10px;\n  border-radius: 15px;\n}", ""]);
// Exports
module.exports = exports;
